import { AppContextProps } from "../AppContext";
import { DialogOptions } from "./DialogOptions";
import MultiChoiceDialogBase, { MultiChoiceDialogBaseProps } from "./MultiChoiceDialogBase";


export class MultiChoiceDialog {

  static Show(ctx: AppContextProps | null, message: string, title: string,
    options: DialogOptions, dflt_values: boolean[] | null,
    props?: Omit<MultiChoiceDialogBaseProps, 'open'>) {

    const dailog = ctx?.ShowDialog(MultiChoiceDialogBase, {

      options: options,
      dflt_values: dflt_values,

      title: title,
      message: message,

      fullWidth: true,

      yesText: "執行",
      yesButtonProps: { variant: 'contained' },

      cancelText: "取消",
      cancelButtonProps: { color: 'inherit' },

      ...props,

      onDialogResult(e) {// 注意! 要放在 ...props 後面覆寫事件

        props?.onDialogResult?.(e);

        if (e.IsCancelClose !== true) {
          dailog?.destroy();
          return
        }
      },

    });

  }

}